import { useCallback } from 'react';

import { useRecoilState } from 'recoil';
import { userSNSState, userTokenState } from 'recoils/user/userState';

import { postAccountUserLogout, postTokenReissue } from 'apis/accountApi';

import usePageNavigate from 'hooks/common/usePageNavigate';
import useViewMode from 'hooks/common/useViewMode';
import usePopupButton from 'hooks/components/usePopupButton';
import useUserInfoWithdrawal from 'hooks/console/userInfo/useUserInfoWithdrawal';

/**
 * @function useHeader
 * @desc Header 컴포넌트에서 사용하는 훅
 * @returns {Object} 헤더 관련 상태 및 핸들러 함수들을 반환
 */
const useHeader = () => {
  const { isMobile } = useViewMode();
  // Recoil 상태 및 상태 업데이트 함수
  const [, setSnsUserInfo] = useRecoilState(userSNSState);
  const [userToken] = useRecoilState(userTokenState);

  // 내부 Hooks
  const { location, onNavClick } = usePageNavigate();
  const { closePopupButton } = usePopupButton();
  const { resetLogout } = useUserInfoWithdrawal();

  /**
   * @function onLoginBtnClick
   * @desc 로그인 버튼 클릭 핸들러
   */
  const onLoginBtnClick = useCallback(() => {
    setSnsUserInfo((prev) => ({
      ...prev,
      isopen: true,
      url: location.pathname,
    }));
  }, [location.pathname, setSnsUserInfo]);

  /**
   * @function onUserBtnClick
   * @desc 유저 버튼 클릭 핸들러
   */
  const onUserBtnClick = useCallback(() => {
    closePopupButton();
    onNavClick('/user-info');
  }, [closePopupButton, onNavClick]);

  /**
   * @function onLogoutBtnClick
   * @desc 로그아웃 버튼 클릭 핸들러
   */
  const onLogoutBtnClick = useCallback(() => {
    // 팝업 닫기
    closePopupButton();

    /**
     * @function handleLogout
     * @desc 로그아웃 프로세스를 실행하는 비동기 함수
     * @returns {Promise<void>} 로그아웃 처리 결과
     */
    const handleLogout = async () => {
      try {
        const { success } = await postAccountUserLogout();
        if (success) {
        }
      } catch (error) {
      } finally {
        resetLogout();
      }
    };

    handleLogout();
  }, [closePopupButton, resetLogout, userToken]);

  const testBtnClick = async () => {
    try {
      const { success } = await postTokenReissue();

      if (success) {
      }
    } catch (refreshError) {
      return Promise.reject(refreshError);
    }
  };

  return {
    onLoginBtnClick,
    onUserBtnClick,
    onLogoutBtnClick,
    testBtnClick,
  };
};

export default useHeader;
